import React, { useState } from "react";
import { connect } from 'react-redux';
import lodash from 'lodash';
import MUIDataTable from "mui-datatables";
import i18n from 'i18n';
import moment from 'moment';

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import MTablestyles from "assets/jss/material-dashboard-pro-react/customMTableStyle.jsx";

import CustomSweetAlert from "components/SweetAlert/CustomSweetAlert.jsx";
import Badge from "components/Badge/Badge.jsx";
import CustomToolbar from "components/CustomToolbar/CustomToolbar.jsx";
import TableActionButton from "components/CustomToolbar/TableActionButton.jsx"
import TableLoaderSpinner from 'components/Table/TableLoaderSpinner'
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import CloudDownload from "@material-ui/icons/CloudDownload";
//import { Parser } from 'json2csv';
//import Button from "components/CustomButtons/Button.jsx";
//import {  alert as customAlert } from 'helpers';
//import Button from "components/CustomButtons/Button.jsx";
//import { Modal, Button } from 'your-ui-library';

import { swalConstants, earnSpecialsConstants, surveyConstants } from '../../constants';
//import { earnSpecialsAction } from "../../actions/earnspecials.actions";
import { surveyAction } from "../../actions/survey.actions";
// import { earnrulesServices } from "services";

import { plugins, crmValidator , loader, alert as customAlert } from "helpers";

//import EarnSpecialsForm from "./EarnSpecialsForm.jsx";
import CreateSurveyForm from "./CreateSurveyForm.jsx";
import QueryForm from './QueryForm.jsx';

const style = {
   customCardContentClass: {
      paddingLeft: "0",
      paddingRight: "0"
   },
   cardIconTitle: {
      ...cardTitle,
      marginTop: "15px",
      marginBottom: "0px"
   },
   actionDiv: {
      display: "inline-flex"
   },
   textCapital: {
      textTransform: "capitalize"
   }
};

const pageStyle = { ...style, ...sweetAlertStyle };

const THEME = createMuiTheme(MTablestyles);
const moduleName = "earn_rule";

const renderBadgeStatus = (status) => {
   let BadgeColor
   switch (status) {
      case "Active": BadgeColor = "success"; break;
      case "Expired": BadgeColor = "danger"; break;
      default: BadgeColor = "gray";
   }
   return (<Badge color={BadgeColor}>{status}</Badge>)
}


class TableSurveyList extends React.Component {
   constructor(props) {
      super(props);

      this.state = {
         readOnly: true,
         page: 0,
         rowsPerPage: 10,
         count: 1,
         data: [],
         reqParams: ""
      };

      this.onSearchChange = lodash.debounce(this.getSurveyData, 500)
   }

   

   getSurveyData = (skip, limit, sortBy, sortDir, keyword) => {
      const { dispatch, tableReload, paramsReport } = this.props;
      let reqParams = "";
      if (!tableReload) {
         if (crmValidator.isEmptyValue(skip)) {
            skip = 0
         }
         if (crmValidator.isEmptyValue(limit)) {
            limit = 10
         }
         this.setState({
            page: skip,
            rowsPerPage: limit
         })
         skip = parseInt(limit) * parseInt(skip)

         reqParams += 'skip=' + skip
         reqParams += '&limit=' + limit

         if (!crmValidator.isEmptyValue(sortBy)) {
            reqParams += '&sortBy=' + sortBy
         }

         if (!crmValidator.isEmptyValue(sortDir)) {
            reqParams += '&sortDir=' + sortDir
         }

         if (!crmValidator.isEmptyValue(keyword)) {
            reqParams += '&keyword=' + keyword
         }

      } else {
         reqParams = this.state.reqParams
      }

      // Function to parse query string into an object
      const parseQueryString = (queryString) => {
         return queryString.split('&').reduce((acc, pair) => {
            const [key, value] = pair.split('=');
            acc[key] = value;
            return acc;
         }, {});
      };

      // Function to convert an object back into a query string
      const objectToQueryString = (obj) => {
            return Object.keys(obj)
               .map(key => `${key}=${obj[key]}`)
               .join('&');
      };

      // Remove old params like skip, limit, sortBy, sortDir, and keyword from paramsReport
      if (paramsReport) {
            let paramsObj = parseQueryString(paramsReport);
            
            // Remove unwanted keys
            delete paramsObj.skip;
            delete paramsObj.limit;
            delete paramsObj.sortBy;
            delete paramsObj.sortDir;
            delete paramsObj.keyword;
            
            // Convert back to a query string
            let filteredParamsReport = objectToQueryString(paramsObj);

            // Combine filtered paramsReport and reqParams
            if (filteredParamsReport) {
               reqParams = `${filteredParamsReport}&${reqParams}`;
            } else {
               reqParams = reqParams;
            }
      }
      
      dispatch(surveyAction.getCompleteSurveyLists(reqParams))
   
      this.setState({
         reqParams: reqParams
      });

   }

   componentDidUpdate() {
      const { tableReload, tableReset, dispatch } = this.props;
      if (tableReload || tableReset) {
         dispatch({ type: surveyConstants.TABLE_RELOAD_SUCCESS })
         //this.getSurveyData();
      }
   }

   componentWillMount() {
      const { dispatch } = this.props;
      dispatch({ type: surveyConstants.CLEAR_PAGE_STATE, data: {} });
      //this.getSurveyData()
   }

   getRowData(rowIndex = 0) {
      const { tableData } = this.props;
      //const data = tableData.earnSpecials;
      const data = tableData.completeSurvey;
      //console.log("data : ",data);
      return data[rowIndex];
   }

   openAnswerModal(answer)  {
      const { dispatch } = this.props
         // Logic to open a modal and display the full answer
         console.log("Full Answer:", answer);
         //simpleAlert(answer);
         customAlert(dispatch, 'info', answer); 
         // You can implement a modal here to show the answer
      };

      // downloadCSV = () => {
      //    const { tableData } = this.props;
      //    const data = tableData.completeSurvey || [];
      
      //    // Prepare CSV headers manually (Date/Time, Survey Topic, Name-Surname, Score, Earn Point)
      //    //let headers = ['Date/Time', 'Survey Topic', 'First Name', 'Last Name', 'Score', 'Earn Point'];
      //    let headers = ['Date/Time', 'Survey Topic', 'First Name', 'Last Name', 'Score'];
      
      //    // Add dynamic question headers (Q1, A1, Q2, A2, ...)
      //    if (data.length > 0) {
      //       const respondent = data[0].respondent;
      //       if (respondent?.questions) {
      //          respondent.questions.forEach((q, index) => {
      //             headers.push(`Q${index + 1}`); // Question header
      //             headers.push(`A${index + 1}`); // Answer header
      //          });
      //       }
      //    }
      
      //    // Prepare CSV data manually
      //    const csvData = data.map(row => {
      //       // Base columns (Date/Time, Survey Topic, Name-Surname, Earn Point)
      //       const rowArr = [
      //          row.created_at ? moment(row.created_at).format('DD/MM/YY HH:mm') : '',
      //           row.survey?.name || '',
      //          // `${row.user?.firstName || ''} ${row.user?.lastName || ''}`.trim(),
      //          row.user?.firstName || '',  // First Name
      //          row.user?.lastName || '',   // Last Name
      //          '',  // Placeholder for Score, will calculate later
      //          //row.survey?.earnPoint || ''
      //       ];
      
      //       // Initialize total score
      //       let totalScore = 0;
      
      //       // Add dynamic question answers (Q1, A1, ...)
      //       const respondent = row.respondent;
      //       if (respondent?.questions) {
      //          respondent.questions.forEach(q => {
      //             // Push the question
      //             //rowArr.push(q.question || '');
      //             rowArr.push((q.question || '').replace(/,/g, ''));
      
      //             // Handle the answer and calculate score
      //             let answer = '';
      //             if (Array.isArray(q.answer) && q.answer.length > 0 && typeof q.answer[0] === 'object') {
      //                // Concatenate 'value-point' and sum up the points
      //                //answer = q.answer.map(item => `${item.value}-${item.point}`).join('-'); // Custom format: value-point
      //                // Check if item.point exists and use 'value-point' format; otherwise, use 'rank' format
      //                answer = q.answer.map(item => {
      //                   if (item.point !== undefined) {
      //                      return `${item.value}-${item.point}`; // Use value-point format
      //                      //return `"${item.value}-${item.point}"`;
      //                   } else if (item.rank !== undefined) {
      //                      return item.rank; // Use rank format if point is not present
      //                      //return `"${item.rank}"`;
      //                   } else {
      //                      return item.value || ''; // Fallback in case rank and point are both missing
      //                      //return `"${item.value || ''}"`;
      //                   }
      //                }).join('-'); // Custom format  
      //                answer = `"${answer}"`                   
      //                totalScore += q.answer.reduce((sum, item) => sum + (item.point || 0), 0); // Sum the points
      //             } else if (typeof q.answer === 'object' && q.answer !== null) {
      //                // If answer is an object, extract values and join them in original order
      //                const objectEntries = Object.entries(q.answer);
      //                //answer = objectEntries.map(([key, value]) => value).join('-');
      //                answer = `"${objectEntries.map(([key, value]) => value).join('-')}"`;
      //             } else {
      //                // Use the single value if it's not an array or object                  
      //                // answer = (q.answer ? q.answer : '') + "-" + (q.point !== undefined ? q.point : '');
      //                // totalScore += q.point || 0;
      //                answer = `"${q.answer ? q.answer : ''}-${q.point !== undefined ? q.point : ''}"`;  // Enclose single values in quotes
      //                totalScore += q.point || 0;
      //             }
      //             rowArr.push(answer); // Store the answer
      //          });
      //       }
      
      //       // Insert the total score into the appropriate position in the array (before 'Earn Point')
      //       rowArr[4] = totalScore;
      
      //       return rowArr;
      //    });
      
      //    // Convert array to CSV string
      //    const csvString = [
      //       headers,  // CSV headers (including Date/Time, Survey Topic, Name-Surname, Score, Earn Point, and Q1, A1, ...)
      //       ...csvData
      //    ].map(e => e.join(",")).join("\n");
      
      //    // Create and download the CSV file
      //    //const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      //    const csvWithBom = "\uFEFF" + csvString;
      //    const blob = new Blob([csvWithBom], { type: 'text/csv;charset=utf-8;' });
      //    const link = document.createElement('a');
      //    link.href = URL.createObjectURL(blob);
      //    link.setAttribute('download', 'survey_data.csv');
      //    document.body.appendChild(link);
      //    link.click();
      //    document.body.removeChild(link);
      
      //    console.log("CSV downloaded successfully");
      // };
      
      downloadCSV = () => {
         const { tableData } = this.props;
         const data = tableData.completeSurveyAll || [];
      
         // Prepare CSV headers manually (Date/Time, Survey Topic, Name-Surname, Score)
         let headers = ['Date/Time', 'Survey Topic', 'First Name', 'Last Name', 'Score'];
      
         // Add dynamic question headers (Q1, A1, P1, Q2, A2, P2, ...)
         if (data.length > 0) {
            const respondent = data[0].respondent;
            if (respondent?.questions) {
               respondent.questions.forEach((q, index) => {
                  headers.push(`Q${index + 1}`); // Question header
                  headers.push(`A${index + 1}`); // Answer header
                  headers.push(`P${index + 1}`); // Point header
               });
            }
         }
      
         // Prepare CSV data manually
         const csvData = data.map(row => {
            // Base columns (Date/Time, Survey Topic, Name-Surname, Earn Point)
            const rowArr = [
               row.created_at ? moment(row.created_at).format('DD/MM/YY HH:mm') : '',
               row.survey?.name || '',
               row.user?.firstName || '',  // First Name
               row.user?.lastName || '',   // Last Name
               '',  // Score placeholder
            ];
      
            // Initialize total score
            let totalScore = 0;
      
            // Add dynamic question answers (Q1, A1, P1, ...)
            const respondent = row.respondent;
            if (respondent?.questions) {
               respondent.questions.forEach((q, index) => {
                  // Push the question
                  rowArr.push((q.question || '').replace(/,/g, ''));
      
                  // Handle the answer and calculate score
                  let answer = '';
                  let point = '';
      
                  if (Array.isArray(q.answer) && q.answer.length > 0 && typeof q.answer[0] === 'object') {
                     answer = q.answer.map(item => item.value || '').join('-'); // Concatenate answer values
                     point = q.answer.map(item => item.point !== undefined ? item.point : '').join('-'); // Concatenate points
      
                     // Sum the points for the total score
                     totalScore += q.answer.reduce((sum, item) => sum + (item.point || 0), 0);
                  } else if (typeof q.answer === 'object' && q.answer !== null) {
                     // If answer is an object, extract values and join them
                     const objectEntries = Object.entries(q.answer);
                     answer = objectEntries.map(([key, value]) => value).join('-');
                  } else {
                     // Single value or no value
                     answer = q.answer ? q.answer : '';
                     point = q.point !== undefined ? q.point : '';
      
                     // Add point to the total score
                     totalScore += q.point || 0;
                  }
      
                  rowArr.push(`"${answer}"`);  // Add the answer (enclosed in quotes)
                  rowArr.push(`"${point}"`);   // Add the point (enclosed in quotes)
               });
            }
      
            // Insert the total score into the appropriate position in the array (before 'Score')
            rowArr[4] = totalScore;
      
            return rowArr;
         });
      
         // Convert array to CSV string
         const csvString = [
            headers,  // CSV headers (including Date/Time, Survey Topic, Name-Surname, Score, Qx, Ax, Px, ...)
            ...csvData
         ].map(e => e.join(",")).join("\n");
      
         // Create and download the CSV file
         const csvWithBom = "\uFEFF" + csvString;
         const blob = new Blob([csvWithBom], { type: 'text/csv;charset=utf-8;' });
         const link = document.createElement('a');
         link.href = URL.createObjectURL(blob);
         link.setAttribute('download', 'survey_data.csv');
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
      
         console.log("CSV downloaded successfully");
      };

   render() {
      const { classes, dispatch, tableData, formInitialValue, tableKey, tableLoader } = this.props;
      const { rowsPerPage, page } = this.state;
      console.log("tableData : ",tableData);
      

      let columns = [       
         
         {
            name: "createDate",
            label: "Date/Time", 
            options: {
               customBodyRender: (value, tableMeta) => {
                  const rowIndex = tableMeta.rowIndex;
                  const rowData = this.getRowData(rowIndex);
                  if (lodash.has(rowData, 'created_at')) {
                     // Format the date using moment.js
                     return moment(rowData.created_at).format('DD/MM/YY HH:mm');
                  } else {
                     return ""
                  }
               }
            }          
         },
         {
            name: "name",
            label: "Survey Topic", 
            options: {
               customBodyRender: (value, tableMeta) => {
                  const rowIndex = tableMeta.rowIndex;
                  const rowData = this.getRowData(rowIndex);
                  //console.log("rowData : ",rowData);
                  if (lodash.has(rowData.survey, 'name')) {
                     return rowData.survey.name;
                  } else {
                     return ""
                  }
               }
            }          
         },
         
         {
            name: "name-surname",
            label: "Name-Surname", 
            options: {
               customBodyRender: (value, tableMeta) => {
                  const rowIndex = tableMeta.rowIndex;
                  const rowData = this.getRowData(rowIndex);
                  if (lodash.has(rowData.user, 'firstName')) {
                     const firstName = rowData.user.firstName || '';
                     const lastName = rowData.user.lastName || '';
                     return `${firstName} ${lastName}`.trim();
                  } else {
                     return "";
                  }
               }
            }          
         },
      
         
      ]

      let options = {
         serverSide: true,
         count: tableData.total,
         page: page,
         rowsPerPage: rowsPerPage,
         print: false,
         search: false,
         customToolbar: () => {
            return (
               <Tooltip title={"Download CSV"}>
                  <IconButton onClick={this.downloadCSV}>
                     <CloudDownload />
                  </IconButton>
               </Tooltip>
            );
         },
         download: false, // Enable CSV download
         downloadOptions: {
            filename: 'survey_data.csv', // File name for the downloaded CSV
            separator: ',', // CSV separator
            filterOptions: {
               useDisplayedRowsOnly: true, // Export only the rows displayed in the table
               //useDisplayedColumnsOnly: true, // Export only the columns displayed in the table
            },
         },
         onDownload: (buildHead, buildBody, columns, data) => {
            console.log("Inside onDownload function"); // Test if this shows
            console.log("Data before processing for CSV download:", data);
        
            return buildHead(columns) + buildBody([]);
          },
         
         
         filter: false,
         selectableRows: "none",
         responsive: "scroll",
         rowsPerPageOptions: [5, 10, 20],
         onTableChange: (action, tableState) => {
            let skip, limit, sortBy, sortDir, keyword = ""

            if (tableState.page !== null) {
               skip = tableState.page
            }

            if (tableState.rowsPerPage !== null) {
               limit = tableState.rowsPerPage
            }

            if (tableState.activeColumn !== null) {
               sortBy = tableState.columns[tableState.activeColumn].name
            }
            if (tableState.announceText !== null) {
               sortDir = tableState.announceText.search("descending") !== -1 ? "desc" : "asc"
            }
            if (tableState.searchText !== null) {
               keyword = tableState.searchText
            }
            let actionList = ['changePage', 'sort',  'changeRowsPerPage']

            if (actionList.indexOf(action) !== -1) {
               // if (action === "search") {
               //    this.onSearchChange(skip, limit, sortBy, sortDir, keyword)
               // } else {
               //    this.getSurveyData(skip, limit, sortBy, sortDir, keyword)
               // }
               this.getSurveyData(skip, limit, sortBy, sortDir, keyword)
            }
         },
      }

      return (
         <div id="tableSurveyList">
            <CustomSweetAlert />
            <QueryForm onSubmit={this.handleQuerySubmit} />  {/* Add the QueryForm here */}
            <CreateSurveyForm
               initialValues={formInitialValue}
               readOnly={!plugins.isHasPermission(moduleName, 'update')}
            />
            <MuiThemeProvider theme={THEME}>
               <MUIDataTable
                  key={tableKey}
                  title={"Report Survey"}
                  //data={tableData.earnSpecials}
                  data={tableData.completeSurvey}
                  columns={columns}
                  options={options}
               />
               {tableLoader && <TableLoaderSpinner />}
            </MuiThemeProvider>

         </div>
         
      )
   }
}

function mapStateToProps(state) {
   const { tableReload, tableReset, tableData, formInitialValue, tableKey, tableLoader, paramsReport } = state.survey;
   const { package_features } = state.authentication;
   return {
      tableReload, tableReset, tableData, formInitialValue, tableKey, tableLoader, package_features, paramsReport
   };
}

export default connect(mapStateToProps)(withStyles(pageStyle)(TableSurveyList));
